import React from 'react';
import {Typography, Button} from "@mui/joy";
import {Box} from "@mui/material";
import {useTranslation} from "react-i18next";
import {ContractEditRounded} from "@mui-symbols-material/w300";
import {ContractDeleteRounded} from "@mui-symbols-material/w200";


interface IoTConnectionWidgetProps {
    assetLocationId?: string;
    clientId?: string;
    variant?: 'add' | 'extend';
}

const IoTConnectionAdmin = ({assetLocationId, clientId, variant = 'add'}: IoTConnectionWidgetProps) => {

    const {t} = useTranslation();

    const headline = variant === 'extend'
        ? t('Contract Expired')
        : t('No Contract Found');
    const description = variant === 'extend'
        ? t('The IoT contract for this company has expired. Extend it to restore IoT access for all users.')
        : t('IoT connections can\'t be set up without a contract in place. Add one for this company and you\'re good to go.');
    const buttonText = variant === 'extend'
        ? t('Extend contract')
        : t('Add contract');

    return (

        <Box sx={{ display: 'flex', border: '1px solid #DB3800', borderRadius: '5px', px:'21px', py:'13px', justifyContent: 'space-between', alignItems: 'center', alignSelf: 'stretch', gap : '13px' }}>
            <Box sx={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                <ContractDeleteRounded sx={{width: 42, height: 42}}/>
                <Box>
                    <Typography level="titleMedium">
                        {headline}
                    </Typography>
                    <Typography level="titleMediumLight">
                        {description}
                    </Typography>
                </Box>
            </Box>
            <Button onClick={() => {window.open(`/crm/customers/${clientId}/contract`, '_blank', 'noopener,noreferrer')}}
                    sx={{display: 'flex', gap:'6px', px: '16px', py:'10px', '&:hover': {backgroundColor:'#BD4200'}}}>
                <ContractEditRounded sx={{width: 20, height: 20}}/>
                <Typography level="bodyBold">
                    {buttonText}
                </Typography>
            </Button>
        </Box>

    )

}

export default IoTConnectionAdmin;